import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import styles from './OrdersSetup.module.scss';

/**
 * OrdersSetup
 *
 * @return {JSX.Element}
 */
const OrdersSetup = ({ className }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.OrdersSetup,
        className,
        OrdersSetup.displayName
      )}
      column
      gap
    >
      <Txt bold>Tenants standing orders are setup 🎉</Txt>
      <Txt regular>
        Congratulations! Your tenants have setup standing orders with their
        banks to pay their share of rent per month.
      </Txt>
      <Txt regular>
        Please note, Propa cannot guarantee a rent payment will be received as
        we do not have access to your bank account. You should regularly check
        your statement for receipt of payment.
      </Txt>
    </FlexContainer>
  );
};

OrdersSetup.displayName = 'OrdersSetup';

export default OrdersSetup;
